import React, { useState, useEffect, useRef } from "react";
import { useTheme, styled } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import { useTranslation } from "react-i18next";
//get DispensingLanguage
const DispensingLanguage =JSON.parse(localStorage.getItem("DispensingLanguage"));
const lan = localStorage.getItem('LangCode');
const menukey = "entry-of-the-results-of-the-various-assessments-for-the-patients";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          className="float-end"
          size="large">
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const LabTestResultModal = ({ handleClose, open, addTestResult, TestId, ...props }) => {
  const { t } = useTranslation();

  const tblLotRefHolder = useRef({ table: null });
  const tblLotRef = tblLotRefHolder.current;
  const ItemGroupId = props.formData.ItemGroupId;
  // const { isLoading, error, isError, data, refetch } = useQuery(
  //   "products_lot",
  //   api.getProductsLot
  // );
  const [tabledata, setTabledata] = useState([]); 
  const { isLoading, error, isError, data, refetch } =  useQuery(['lab-test-result-list', ItemGroupId, TestId], () =>
    api.getLabTestResultModalList(ItemGroupId, TestId).then((res) => {
      setTabledata(res);
      return res?.data ?? null;
    }), {
    enabled: Boolean(ItemGroupId, TestId)
  })



  // const [selectedProducts, setselectedProducts] = useState([]);

  const ProductColumns = [
    { title: "TestId", field: "TestId", visible: false },
    { title: t(DispensingLanguage[lan][menukey]['Sl#']),  formatter: "rownum", width:50, hozAlign: "center" , headerHozAlign:"center", headerSort:false},
    { title: t(DispensingLanguage[lan][menukey]['Test Result']), field: "TestResultName", headerFilter:true  },
   
  ];


  
  const ProdustDataItemsLot = tabledata?.map((item, index) => { 
    return item;
  });

  let selectedRows = [];
  
  const [btnDisable, setbtnDisable] = useState(false);
  const SaveSelectedProducts = () => { 

    //console.log("All Product >>>> ",ProdustDataItemsLot);
    //console.log("Product modal selected product >>>> ",tblLotRef.table.getSelectedData());

    if(tblLotRef.table.getSelectedData().length>0){
      setbtnDisable(true);
      selectedRows = tblLotRef.table.getSelectedData();
     // checkExpiringBatches();
     addTestResult(tblLotRef.table.getSelectedData());  
      setTimeout(() => setbtnDisable(false), 500);
    }  
  };
 
  // const checkSelect = (row) => { 
  //   console.log(row);
  //   console.log("row");
  // };

  useEffect(() => {
    if (tblLotRef.table == null) return;

}, []);
  return (
    <div>
      <BootstrapDialog
        onClose={() => handleClose('LabResultClose')}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth="xs" 
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={() => handleClose('LabResultClose')}
        >
          {t(DispensingLanguage[lan][menukey]['Lab Test Result List'])} 
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <ReactTabulator
            onRef={(rf) => { tblLotRef.table = rf.current; }}
            options={{
              selectableRowsRangeMode: 'click',
              selectableRows: 1,
             }}
            columns={ProductColumns}
            data={ProdustDataItemsLot}
            height="300px"
            layout={"fitColumns"}
            //selectableCheck={(row)=>checkSelect(row)}


          />
        </DialogContent>
        <DialogActions>
          <Button
            disabled={btnDisable}
            className="me-2 float-start"
            variant="contained"
            color="primary"
            onClick={SaveSelectedProducts}
          >
            {t(DispensingLanguage[lan][menukey]['ADD'])}  
          </Button>
          <Button
            autoFocus
            className="float-start"
            variant="contained"
            color="gray"
            onClick={() => handleClose('LabResultClose')}
          >
           {t(DispensingLanguage[lan][menukey]['CANCEL'])}   
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default LabTestResultModal;

const useStyles = makeStyles({
  fullWidth: {
    width: "100%",
  },
});